import { KEYS_TAGS } from '@components/imageHandling/common';

const SCOPE_ID_MAP: Record<string, number> = {
  Part: KEYS_TAGS.Part,
  NcFile: KEYS_TAGS.Clamping, // NC Files use Clamping scope
  ProductionBatch: KEYS_TAGS.ProductionBatch,
  ProductionOrder: KEYS_TAGS.ProductionOrder,
  Operation: KEYS_TAGS.Operation,
};

export const getScopeIdForItemType = (itemType: string): number | null => {
  return SCOPE_ID_MAP[itemType] ?? null;
};

export const TEXT_MAPPING: Record<string, string> = {
  Part: 'Part',
  ProductionBatch: 'Batch',
  NcFile: 'NC File',
  Tool: 'Tool',
  ImageDocument: 'Image',
  OtherDocument: 'Document',
};
